import React from 'react';
import PropTypes from 'prop-types';

import {SearchFilter} from '@utils/commonFilters/SearchFilter';
import {FiltersWrapper} from '@appComponents/HOCFiltersWrapper';

export const SequenceConfigFilters = (props) => {
    return (
        <div className='filter__controls__container'>
            <SearchFilter
                loading={props.loading}
                filters={props.filters.SequenceConfig}
                restoreFilterValues={props.restoreFilterValues}
            />
        </div>
    );
};

SequenceConfigFilters.propTypes = {
    restoreFilterValues: PropTypes.func.isRequired,
    filters: PropTypes.shape({
        SequenceConfig: PropTypes.object,
    }).isRequired,
    loading: PropTypes.bool.isRequired,
};

export default FiltersWrapper(SequenceConfigFilters, {name: 'SequenceConfig'});
